module.exports = __webpack_public_path__ + "static/media/icon_file_loading.e6aabcf1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/icon_file_loading.svg
// module id = 83
// module chunks = 0